import lodashSumBy from 'lodash/sumBy'

import React from 'react'
import { Link } from 'react-router-dom'
import type {
  Contact,
  PlaylistActivity,
  TAggregatedEventsEnum2,
} from 'types/list'
import StatsTableEmpty from 'components/common/stats-table/stats-table-empty'
import HelpTooltip from 'components/common/tooltip'
import DataTable from 'components/ui/data-table'
import Spinner from 'components/ui/spinner'
import ContactCard from '../contact-card'
export const renderPlaylistCell = (
  row: PlaylistActivity,
  label: string,
  aggregatedEventType: TAggregatedEventsEnum2,
): React.ReactNode | number => {
  const { tracks: track_stats, stats } = row
  const itemWithTooltip = !track_stats.some(
    item => item.stats[aggregatedEventType],
  ) ? (
    stats[aggregatedEventType] || 0
  ) : (
    <HelpTooltip
      base={
        <div>
          {lodashSumBy(track_stats, x => x.stats[aggregatedEventType]) || 0}
        </div>
      }
      customScrollbars
    >
      <div>
        <b>{label}</b>
      </div>
      <div>
        <br />
      </div>

      {track_stats
        .map(item => ({
          name: item.name,
          count: item.stats[aggregatedEventType],
        }))
        .filter(item => item.count)
        .map((item, index) => (
          <div key={index}>
            {item.name} - {item.count}
          </div>
        ))}
    </HelpTooltip>
  )
  return itemWithTooltip
}

class ActivityTab extends React.Component<{
  contact: Contact
}> {
  renderContent(): React.ReactElement<'div'> | React.ReactNode {
    const { contact } = this.props

    if (contact.activityLoading) {
      return <Spinner />
    } else if (contact.activityLoadingError) {
      return <div>{contact.activityLoadingError.toString()}</div>
    } else {
      return (
        <DataTable
          columns={[
            {
              name: 'Name',
              render: (props: Record<string, any>) => (
                <Link to={`/explorer/playlists/${props.id}`}>{props.name}</Link>
              ),
            },
            {
              name: 'Page views',
              width: 'content',
              render: (props: Record<string, any>) =>
                renderPlaylistCell(
                  props as any,
                  'Page views',
                  'access_playlist',
                ),
            },
            {
              name: 'Playlist downloads',
              width: 'content',
              render: (props: Record<string, any>) =>
                renderPlaylistCell(
                  props as any,
                  'Playlist downloads',
                  'download_zip',
                ),
            },
            {
              name: 'Track downloads',
              width: 'content',
              render: (props: Record<string, any>) =>
                renderPlaylistCell(
                  props as any,
                  'Track downloads',
                  'download_track',
                ),
            },
            {
              name: 'Streams',
              width: 'content',
              render: (props: Record<string, any>) =>
                renderPlaylistCell(props as any, 'Streams', 'play_track'),
            },
          ]}
          data={contact.activity}
          rows={5}
          emptyState={
            <StatsTableEmpty cta="Generate some activity by sharing some music with this contact." />
          }
        />
      )
    }
  }

  render(): React.ReactNode {
    return <ContactCard>{this.renderContent()}</ContactCard>
  }
}

export default ActivityTab
